(function () {
  'use strict';
  var serviceId = 53147365998873;
  var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  var requestLabel = '$25 certification service selected; allow at least 8–10 days';
  async function json(url, options) {
    var response = await fetch(root + url, options);
    var body = await response.json();
    if (!response.ok) throw new Error(body.description || 'Could not update your cart. Please try again.');
    return body;
  }
  async function prepare(items, stone, requested) {
    if (!requested) return items;
    var product = await json('products/diamond-certification-service.js');
    var service = product.variants.find(function (v) { return v.id === serviceId; });
    if (!service || !service.available || service.price !== 2500) throw new Error('Certification is unavailable right now. Please contact us before ordering.');
    var diamond = items.find(function (item) { return String(item.id) === String(stone.variant_id); });
    if (!diamond) throw new Error('Please select your diamond again.');
    var group = 'C' + Date.now().toString(36) + Math.random().toString(36).slice(2,8);
    diamond.properties = Object.assign({}, diamond.properties, { _certification_group: group, 'Certification request': requestLabel });
    var properties = { _certification_group: group, _certification_service: 'true', 'Diamond reference': String(stone.stone_no || stone.sku || stone.variant_id), 'Turnaround': 'At least 8–10 days; laboratory and dispatch timing confirmed with you' };
    if (diamond.properties._ring) properties._ring = diamond.properties._ring;
    items.push({ id: serviceId, quantity: 1, properties: properties });
    return items;
  }
  window.ClavisCertification = { prepare: prepare, serviceId: serviceId };
  document.querySelectorAll('[data-cert-service-choice]').forEach(function (choice) {
    choice.disabled = false;
    var form = choice.form;
    if (!form) return;
    form.addEventListener('submit', async function (event) {
      if (!choice.checked) return;
      event.preventDefault();
      var button = form.querySelector('[type="submit"]');
      if (button.disabled) return;
      button.disabled = true;
      var error = form.querySelector('[data-cert-error]');
      error.textContent = '';
      try {
        var data = new FormData(form), properties = {};
        data.forEach(function (value,key) { var m = key.match(/^properties\[(.+)\]$/); if(m) properties[m[1]] = value; });
        var variantId = Number(data.get('id'));
        var items = await prepare([{ id: variantId, quantity: 1, properties: properties }], { variant_id: variantId, stone_no: choice.dataset.stone }, true);
        await json('cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:items}) });
        location.href = root + 'cart';
      } catch(e) { error.textContent = e.message; button.disabled = false; }
    });
  });
})();
